module.exports = __webpack_public_path__ + "img/2-min (12).445924c5.png";